import { jsonCopy } from '../../../utility/genericUtility';
import { datiEsecutoreInizializzato} from '../componentiBase/sezioniAnagrafica';

export const datiEsecutore = jsonCopy(datiEsecutoreInizializzato);